import "maplibre-gl/dist/maplibre-gl.css";
import "./viewer-v2.css";
import { ContentLayout } from "@amzn/awsui-components-react";
import { useEffect } from "react";
import Layout from "../layout/Layout";
import { MAP_PAGE_STYLE } from "../common/MapUtils";
import { OptionsMenuPanel } from "./ui/ConfigBar";
import MapLocationBar from "./ui/MapLocationBar";
import { MapContainer, useViewerController } from "./react";
import { usePanelStore } from "./state";

/**
 * Single-view Viewer 2.0. The Options menu (top-left) holds Map Configuration
 * plus the panel actions; panels open in the shared AppLayout's native
 * SplitPanel (resizable, side/bottom) — wired in Layout for viewer-v2 routes.
 * On-map controls + location bar overlay the map.
 */
const ViewerV2 = () => {
    const c = useViewerController();
    const setEngineHandle = usePanelStore((s) => s.setEngineHandle);
    const openPanel = usePanelStore((s) => s.openPanel);

    // Publish the engine handle so the Layout-hosted SplitPanel content can
    // drive the map without prop-drilling through the shared Layout.
    useEffect(() => {
        setEngineHandle(c.handle);
    }, [c.handle, setEngineHandle]);

    // The native SplitPanel reflows AppLayout's content area when it opens/closes;
    // nudge MapLibre to re-measure so the canvas fills the new map area.
    useEffect(() => {
        const t = window.setTimeout(() => c.handle?.engine()?.resize(), 50);
        return () => window.clearTimeout(t);
    }, [openPanel, c.handle]);

    return (
        <Layout>
            <ContentLayout>
                <div style={MAP_PAGE_STYLE}>
                    <div style={{ position: "relative", width: "100%", height: "100%" }}>
                        <MapContainer onReady={c.onMapReady} />
                        <OptionsMenuPanel
                            draft={c.draft}
                            options={c.options}
                            dirty={c.dirty}
                            refreshing={c.refreshing}
                            updating={c.updating}
                            onChange={c.onChange}
                            onRefresh={c.onRefresh}
                            onUpdate={c.onUpdate}
                        />
                        <MapLocationBar />
                    </div>
                </div>
            </ContentLayout>
        </Layout>
    );
};

export default ViewerV2;
